export default __webpack_public_path__ + "static/media/geometry-dash@2x.7862a096.webp";